import React, {
	createContext,
	useCallback,
	useContext,
	useEffect,
	useMemo,
	useState,
} from 'react';

const WarehouseSeriesControlContext = createContext({
	isEditMode: false,
	isSubmitting: false,
	resetVersion: 0,
	reset: () => {},
	setEditMode: () => {},
	setSubmitting: () => {},
	toggleEditMode: () => {},
});

export const WarehouseSeriesControlProvider = ({ children, resetKey }) => {
	const [isEditMode, setEditMode] = useState(false);
	const [isSubmitting, setSubmitting] = useState(false);
	const [resetVersion, setResetVersion] = useState(0);

	const reset = useCallback(() => {
		setEditMode(false);
		setSubmitting(false);
		setResetVersion(current => current + 1);
	}, []);

	const toggleEditMode = useCallback(() => {
		if (isSubmitting) return;
		setEditMode(current => !current);
	}, [isSubmitting]);

	useEffect(() => {
		reset();
	}, [resetKey, reset]);

	const value = useMemo(
		() => ({
			isEditMode,
			isSubmitting,
			resetVersion,
			reset,
			setEditMode,
			setSubmitting,
			toggleEditMode,
		}),
		[isEditMode, isSubmitting, resetVersion, reset, toggleEditMode],
	);

	return (
		<WarehouseSeriesControlContext.Provider value={value}>
			{children}
		</WarehouseSeriesControlContext.Provider>
	);
};

export const useWarehouseSeriesControl = () =>
	useContext(WarehouseSeriesControlContext);

export default WarehouseSeriesControlContext;
